import React, { useEffect, useState } from 'react';
import LogFilesDemoData from '../../../../data/LogFilesDemoData';
import LayoutProvider from '../../../Contexts/LayoutProvider';
import { useTemplate } from '../../../features/template/TemplateProvider';
import LogFilesPageHeader from './Components/LogFilesPageHeader';
import LogFilesPageHeaderMobile from './Components/LogFilesPageHeaderMobile';
import LogFilesPageTableMobile from './Components/LogFilesPageTableMobile';
import LogsFilesPageTable from './Components/LogsFilesPageTable';
import { ApiLogsFilesListOpe } from './LogFilesListOperation';

function LogFilesListPage() {
    const { setMessage } = useTemplate();
    const [logsData, setLogsData] = useState(LogFilesDemoData);
    const [reloadKey, setReloadKey] = useState(0);
    const [formData, setFormData] = useState({ q: '' });
    const handleReload = () => {
        setReloadKey((cu) => cu + 1);
    };
    useEffect(() => {
        setLogsData(LogFilesDemoData);
        ApiLogsFilesListOpe()
            .then(({ data }) => {
                setLogsData(data.files);
            })
            .catch((err) => {
                setLogsData([]);
                setMessage({ type: 'error', text: err.toString(0) });
            });
    }, [reloadKey, setMessage]);

    const handleChangeFilterData = (ev) => {
        const { name, value } = ev.target;
        if (name) {
            setFormData((d) => ({ ...d, [name]: value }));
        }
    };
    const filterData = logsData.filter((item) =>
        item?.name?.toLowerCase().includes(formData?.q?.toLowerCase())
    );

    return (
        <div className="log_file_page inner_page_cont">
            <LayoutProvider>
                <LogFilesPageHeader
                    layout="default"
                    onChangeHandler={handleChangeFilterData}
                    handleReload={handleReload}
                    p={formData}
                />
                <LogFilesPageHeaderMobile
                    layout={['md', 'sm', 'xs', 'xxs']}
                    p={formData}
                    onChangeHandler={handleChangeFilterData}
                    handleReload={handleReload}
                />
            </LayoutProvider>
            <LayoutProvider>
                <LogsFilesPageTable
                    layout="default"
                    data={filterData}
                    handleReload={handleReload}
                />
                <LogFilesPageTableMobile
                    layout={['md', 'sm', 'xs', 'xxs']}
                    data={filterData}
                    handleReload={handleReload}
                />
            </LayoutProvider>
        </div>
    );
}

export default LogFilesListPage;
